import React from 'react';
import { Route } from 'react-router-dom';

import { HomepageNavbar } from './HomepageNavbar';

import { Homepage } from './Homepage';

export const HomepageRoute = (
    <Route
        path="/homepage"
        render={() => (
            <React.Fragment>
                <Route component={HomepageNavbar} />
                <Homepage />
            </React.Fragment>
        )}
    />
);
